import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// ============================================
// FIX 1: Remove './pages/' from path
// Kyunki files seedha src folder me hain
// ============================================
import HomePage from "./HomePage";
import AboutUsPage from "./AboutUsPage";
import ServicesPage from "./ServicesPage";
import CollegeListingPage from "./CollegeListingPage"; // Ensure ye file src me exist karti ho
import ContactUsPage from "./ContactUsPage"; // Agar ye bhi use kar rahe hain

// ============================================
// FIX 2: Correct Footer Path & Filename
// Screenshot me naam 'footer.jsx' (small f) hai
// ============================================
import Footer from "./components/footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp"; // Agar ye file banayi hai to
import ScrollToTop from "./components/ScrollToTop";


function App() {
  return (
    <Router>
      <ScrollToTop />

      {/* Global Components */}
      <FloatingWhatsApp />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/colleges" element={<CollegeListingPage />} />
        <Route path="/contact" element={<ContactUsPage />} />

      </Routes>

      {/* Global Footer */}
      <Footer />
    </Router>
  );
}

export default App;
